import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Row, Col } from 'antd'
import '../../css/regimen.scss'

const FilterList = (props) => {
  return props.filters && Object.keys(props.filters).length == 0 ? (
    <Row style={{ height: '100%' }} gutter={'10'}>
      <Col style={{ alignSelf: 'center' }} span={6}>
        {'No filters applied.'}
      </Col>
    </Row>
  ) : (
    <>
      <Row hidden={!props.filters?.surgery_type} gutter={'10'}>
        <Col style={{ fontWeight: 'bold' }} span={4}>
          {'Surgery type'}
        </Col>
        <Col span={8}>:&nbsp;{props.filters?.surgery_type?.join(', ')}</Col>
      </Row>
      <Row hidden={!props.filters?.age_group} gutter={'10'}>
        <Col style={{ fontWeight: 'bold' }} span={4}>
          {'Age group'}
        </Col>
        <Col span={8}>:&nbsp;{props.filters?.age_group?.join(', ')}</Col>
      </Row>
      <Row hidden={!props.filters?.gender} gutter={'10'}>
        <Col style={{ fontWeight: 'bold' }} span={4}>
          {'Gender'}
        </Col>
        <Col span={8}>:&nbsp;{props.filters?.gender?.join(', ')}</Col>
      </Row>
    </>
  )
}

FilterList.propTypes = {
  customer: PropTypes.object,
  filters: PropTypes.object,
}

const mapStateToProps = (state) => {
  return {
    customer: state.profile.customer,
    filters: state.regimen.filters,
  }
}

export default connect(mapStateToProps, null)(FilterList)
